import { fetchDemandReport } from 'BudgetModule/services/demandReport';
import { useAppQuery } from 'core/query/hooks/useAppQuery';
import { teamQueryKeys } from '../teamQueryKeys';
import {
  FetchDemandReportAxiosSuccessResponse,
  FetchTeamDemandReportPayload,
  FetchDemandReportAxiosErrorResponse,
} from 'BudgetModule/services/types';
import { FIVE_MINUTES } from '@constants/date';

export const useTeamDemandReportQuery = (params: FetchTeamDemandReportPayload) => {
  const { team_id } = params;

  const query = useAppQuery<
    FetchDemandReportAxiosSuccessResponse,
    FetchDemandReportAxiosErrorResponse
  >({
    queryKey: teamQueryKeys.detail({
      teamId: team_id,
      identifier: `useTeamDemandReportQuery`,
    }),
    queryFn: ({ token, buildConfig }) =>
      // buildConfig() automatically includes URL context headers (tenant/realmId)
      fetchDemandReport({
        params,
        token,
        config: buildConfig(),
      }) as Promise<FetchDemandReportAxiosSuccessResponse>,
    staleTime: FIVE_MINUTES,
  });

  return {
    teamDemandReportData: query.data?.data,
    teamDemandReportError: query.error?.data
      ? (query.error?.data?.errors?.[0] ?? 'Something went wrong')
      : undefined,
    isLoadingTeamDemandReport: query.isLoading,
  };
};
